import Home from "../components/Home";
import Header from "../components/Header";
import { Helmet } from "react-helmet";
import comming_soon from "../assets/comming_soon.png";

export default function WebHome() {
  return (
    <div>
      <Helmet>
        <title>Features | Andromeda</title>
        <meta
          name="description"
          content="Get in touch with us through our contact page."
        />
        <meta name="keywords" content="contact, support, help, andromeda sim" />
      </Helmet>

      <Header />

      <Home />
    </div>
  );
}
